// Set utils function parseTime to filter
export { parseTime } from '@/utils'
import { dateToDatezone, dateToTimezone } from '@/utils/dateTime'
import moment from 'moment'

// Filter for article status
export const articleStatusFilter = (status: string) => {
  const statusMap: { [key: string]: string } = {
    published: 'success',
    draft: 'info',
    deleted: 'danger'
  }
  return statusMap[status]
}

// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const stringArrayToString = (list: string[]) => {
  let str: string = ''
  for (let i = 0; i < list.length; i++) {
    str += list[i]
    if (i !== list.length - 1) {
      str += ';'
    }
  }
  return str
}

export const stringToStringArray = (str: string) => {
  return str.replace(/\s*/g, "").split(';')
}

// 第一个字母大写
export const firstToUpper = (str: string) => {
  return str.trim().replace(str[0], str[0].toUpperCase())
}

export const toString = (str: string) => {
  const strs = str.split('_')
  let s = ''
  strs.forEach((item: string) => {
    s += firstToUpper(item) + ' '
  })
  return s + '：'
}

export const dateFormat = (obj: any) => {
  return obj ? dateToTimezone(obj * 1000) : ''
}

export const dateFormatMini = (obj: any) => {
  return obj ? dateToDatezone(obj * 1000) : ''
}

export const timeSplice = (str: string) => {
  return str.split('.')[0]
}
